import { render, staticRenderFns } from "./MultipleChoicePanel.vue?vue&type=template&id=00a95c79&"
import script from "./MultipleChoicePanel.vue?vue&type=script&lang=js&"
export * from "./MultipleChoicePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports